// Wrapper fino sobre las Cloud Functions de Inteligencia Competitiva
// (competidores, alertas y financiamiento) — Postgres/Neon.
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const sugerirCompetidoresFn = httpsCallable(functions, 'sugerirCompetidores');
const agregarCompetidorFn = httpsCallable(functions, 'agregarCompetidor');
const quitarCompetidorFn = httpsCallable(functions, 'quitarCompetidor');
const guardarAlertaConfigProyectoFn = httpsCallable(functions, 'guardarAlertaConfigProyecto');
const listarMisAlertasFn = httpsCallable(functions, 'listarMisAlertas');
const marcarAlertaLeidaFn = httpsCallable(functions, 'marcarAlertaLeida');
const marcarTodasLeidasFn = httpsCallable(functions, 'marcarTodasLeidas');
const contarAlertasNoLeidasFn = httpsCallable(functions, 'contarAlertasNoLeidas');
const agregarOfertaFinanciamientoFn = httpsCallable(functions, 'agregarOfertaFinanciamiento');
const eliminarOfertaFinanciamientoFn = httpsCallable(functions, 'eliminarOfertaFinanciamiento');
const listarOfertasFinanciamientoFn = httpsCallable(functions, 'listarOfertasFinanciamiento');
const obtenerComparadorFinancieroFn = httpsCallable(functions, 'obtenerComparadorFinanciero');

// [{ id, marca, model, modelDetail, precio }] — candidatos dentro de ±15%
// de precio, misma categoría y tipo de motor. Lanza failed-precondition si
// el modelo no tiene categoría/tipo de motor/precio curados todavía.
export async function sugerirCompetidores(listaId, vehicleVersionId) {
  const result = await sugerirCompetidoresFn({ listaId, vehicleVersionId });
  return result.data.candidatos;
}

export async function agregarCompetidor(listaId, vehicleVersionId, competidorVehicleVersionId, origen = 'manual') {
  await agregarCompetidorFn({ listaId, vehicleVersionId, competidorVehicleVersionId, origen });
}

export async function quitarCompetidor(listaId, vehicleVersionId, competidorVehicleVersionId) {
  await quitarCompetidorFn({ listaId, vehicleVersionId, competidorVehicleVersionId });
}

// umbralPrecioPct: % de variación que dispara alerta de precio (default 2).
export async function guardarAlertaConfigProyecto(listaId, vehicleVersionId, config) {
  await guardarAlertaConfigProyectoFn({ listaId, vehicleVersionId, ...config });
}

// { alertas: [{ id, tipoEvento, valorAnterior, valorNuevo, deltaPorcentual, severidad, leido, createdAt, vehiculo, competidor }] }
export async function listarMisAlertas({ soloNoLeidas, limit } = {}) {
  const result = await listarMisAlertasFn({ soloNoLeidas, limit });
  return result.data.alertas;
}

export async function marcarAlertaLeida(id) {
  await marcarAlertaLeidaFn({ id });
}

export async function marcarTodasLeidas() {
  await marcarTodasLeidasFn();
}

export async function contarAlertasNoLeidas() {
  const result = await contarAlertasNoLeidasFn();
  return result.data.count;
}

export async function agregarOfertaFinanciamiento(listaId, vehicleVersionId, oferta) {
  const result = await agregarOfertaFinanciamientoFn({ listaId, vehicleVersionId, ...oferta });
  return result.data.oferta;
}

export async function eliminarOfertaFinanciamiento(id) {
  await eliminarOfertaFinanciamientoFn({ id });
}

export async function listarOfertasFinanciamiento(listaId, vehicleVersionId) {
  const result = await listarOfertasFinanciamientoFn({ listaId, vehicleVersionId });
  return result.data.ofertas;
}

// {
//   filas: [{ vehicleVersionId, vehiculo, esPropio, precioLista, tipoPrecio,
//             bonoPie, bonoDirecto, descuentoTotal, descuentoPct, precioEfectivo,
//             pieMonto, plazoMeses, tasaAnual, cuotaMensual, cuotaEsEstimada,
//             costoTotalCredito, sobrecostoFinanciero, valueScore, scoreEquipamiento,
//             posicionLista, posicionEfectivo, gapVsPropio, gapVsPropioPct,
//             oferta, sinOferta }],
//   resumen: { disponible, posicionEfectivo, posicionLista, totalComparados, lider,
//              brechaAlLider, bonoParaLiderar, precioPromedioSet, descuentoPropioPct,
//              descuentoPromedioCompetencia, valueScorePropio, valueScorePromedioSet,
//              competidoresSinOferta, totalCompetidores, lecturas: [{tono, texto}] }
// }
export async function obtenerComparadorFinanciero(listaId, vehicleVersionId) {
  const result = await obtenerComparadorFinancieroFn({ listaId, vehicleVersionId });
  return result.data;
}
